import StringMask from 'string-mask'

export const cnpj = new StringMask('99.999.999/9999-99', { reverse: true })
export const cpf = new StringMask('999.999.999-99', { reverse: true })
export const money = new StringMask('#.##0,00', { reverse: true })
export const percentage = new StringMask('0,099')
export const phone = new StringMask('(00) 90000-0000', { reverse: true })
export const zipcode = new StringMask('99.999-999', { reverse: true })

export const cognitoCode = new StringMask('#0', { reverse: true })

export default {
  cnpj,
  cpf,
  money,
  percentage,
  phone,
  zipcode,
  cognitoCode
}
